import React from "react"

import ScenarioThemeValidatorComponent from "./scenario-theme-validator-component"

class ScenarioThemeValidatorContainer extends React.Component {

	render() {
		const validator = this.props.scenario.validated_themes.find(vt => vt.theme_id == this.props.theme.id)
		const toggle = this.props.toggle
		return (
			<ScenarioThemeValidatorComponent
				theme={this.props.theme}
				validator={validator}
				onThemeValidToggle={this._handleValidTheme.bind(this, validator,toggle)}
			/>
		)
	}

	_handleValidTheme(validator,toggle) {
		this.props.onThemeValidated(this.props.theme, !validator || !validator.validated,toggle)
	}

}

export default ScenarioThemeValidatorContainer



// WEBPACK FOOTER //
// ./src/component/scenarii/admin/scenario-theme-validator-container.js